// ============================================================
// Fee Installment Service
// ============================================================

import { feeInstallmentsApi } from '@/api/feeInstallments.api';
import { generateId } from '@/utils/generateId';

const initialMockInstallments = {};

export const feeInstallmentService = {
  getInstallments: async (feeStructureItemId) => {
    if (!feeStructureItemId) return [];
    try {
      const res = await feeInstallmentsApi.getInstallments(feeStructureItemId);
      return Array.isArray(res) ? res : res?.installments || res?.data || [];
    } catch (err) {
      console.warn('API error fetching installments, using mock fallback:', err.message);
      return initialMockInstallments[feeStructureItemId] || [];
    }
  },

  createInstallments: async (feeStructureItemId, payloadArray) => {
    if (!feeStructureItemId) throw new Error('Fee Structure Item ID is required');
    try {
      const res = await feeInstallmentsApi.createInstallments(feeStructureItemId, payloadArray);
      return { success: true, installments: res?.installments || [], message: res?.message || 'Installments created successfully' };
    } catch (err) {
      if (err.response) {
        const errorMsg = err.response?.data?.detail || err.response?.data?.message || err.message || 'Failed to create installments';
        throw new Error(errorMsg);
      }
      console.warn('API error creating installments, saving locally:', err.message);
      const created = payloadArray.map((inst, index) => ({
        id: generateId('inst-'),
        installment_no: index + 1,
        fee_structure_item_id: feeStructureItemId,
        is_active: true,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        ...inst,
      }));
      initialMockInstallments[feeStructureItemId] = created;
      return { success: true, installments: created, message: 'Installments created successfully' };
    }
  },

  updateInstallment: async (installmentId, payload) => {
    if (!installmentId) throw new Error('Installment ID is required');
    try {
      const res = await feeInstallmentsApi.updateInstallment(installmentId, payload);
      return { success: true, installment_id: res?.installment_id || installmentId, message: res?.message || 'Installment item updated successfully' };
    } catch (err) {
      if (err.response) {
        const errorMsg = err.response?.data?.detail || err.response?.data?.message || err.message || 'Failed to update installment';
        throw new Error(errorMsg);
      }
      console.warn('API error updating installment:', err.message);
      return { success: true, installment_id: installmentId, message: 'Installment item updated successfully' };
    }
  },

  deleteInstallment: async (installmentId) => {
    if (!installmentId) throw new Error('Installment ID is required');
    try {
      const res = await feeInstallmentsApi.deleteInstallment(installmentId);
      return { success: true, message: res?.message || 'Installment deleted successfully' };
    } catch (err) {
      if (err.response) {
        const errorMsg = err.response?.data?.detail || err.response?.data?.message || err.message || 'Failed to delete installment';
        throw new Error(errorMsg);
      }
      console.warn('API error deleting installment:', err.message);
      return { success: true, message: 'Installment deleted successfully' };
    }
  },
};
